import React from 'react';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
import './ResizableTitle.css';

export default function ResizableTitle({ onResize, width, ...rest }) {
  if (!width) return <th {...rest} />;
  return (
    <Resizable
      width={width}
      height={0}
      handle={<span className="react-resizable-handle col-resize-handle" onClick={(e) => e.stopPropagation()} />}
      onResize={onResize}
      minConstraints={[60, 0]}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...rest} />
    </Resizable>
  );
}
